/* eslint-disable no-unused-vars */
/* global G */
import { curry } from 'lib/util'
import getQuickAction from 'app/_shared/events/appbar/quickActions/get'

/**
 * Show Quick Action Event Handler
 *
 * Looks up `action` in the current action's UI configuration
 * and shows it if it's hidden.
 *
 * @param {string} action                 name of the action to return
 * @param {Gaia.AppModule.Spec} module    the current module composition object
 * @param {Gaia.Component.Spec} component the current action's main component
 * @param {Event} event                   the event object that triggered this handler
 * @returns {*|null}
 */
const showQuickAction = (action, module, component, event) => {
  const quickAction = getQuickAction(action, module, component, event)
  quickAction && (quickAction.hidden = false)
}

export default curry(showQuickAction)
